import React from "react";

const LoadedText = ({ text = "" }) => {
  return (
    <span className="d-flex align-items-center justify-content-center">
      {text}
    </span>
  );
};

export default LoadedText;
